import '../descope-email-field';
import '../phone-fields/descope-phone-field';
import '../phone-fields/descope-phone-input-box-field';

import { componentName, HybridFieldClass } from './HybridFieldClass';

customElements.define(componentName, HybridFieldClass);

export { HybridFieldClass, componentName };
